export const WholesaleInquiryOfferStatus = Object.freeze({
    new: Symbol('new'),
    selected: Symbol('selected'),
    rejected: Symbol('rejected'),
});

export function getOfferStatusText(status) {
    return {
        [WholesaleInquiryOfferStatus.new]: 'Nowy',
        [WholesaleInquiryOfferStatus.selected]: 'Zaakceptowana',
        [WholesaleInquiryOfferStatus.rejected]: 'Odrzucona',
    }[WholesaleInquiryOfferStatus[status]];
}
